import { useNavigate } from "react-router-dom";
import { ThumbsUp, ThumbsDown, ExternalLink, Bookmark, MoreHorizontal } from "lucide-react";
import { VBACodeBlock } from "@/components/VBACodeBlock";
import verifiedBadge from "@/assets/verified-badge.png";
import macroVaultLogo from "@/assets/macrohub-logo.png";
const codeExample = `Sub SortSheetsTabName()
    Application.ScreenUpdating = False
    Dim ShCount As Integer, i As Integer, j As Integer
    ShCount = Sheets.Count
    For i = 1 To ShCount - 1
        For j = i + 1 To ShCount
            If Sheets(j).Name < Sheets(i).Name Then
                Sheets(j).Move before:=Sheets(i)
            End If
        Next j
    Next i
    Application.ScreenUpdating = True
End Sub`;
export const CodeShowcaseSection = () => {
  const navigate = useNavigate();
  const modules = [{
    id: "1",
    name: "Module1",
    code: codeExample
  }];
  
  return <section className="py-24 bg-background">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="space-y-4 md:space-y-6">
          {/* CTA Text */}
          <div className="text-center space-y-6 pb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground">
              Start accelerating your Excel work today.
            </h2>
          </div>
          
          {/* Code Block */}
          <VBACodeBlock modules={modules} />
          
          {/* Macro Title */}
          <h1 className="text-[28px] sm:text-[32px] font-bold tracking-tight leading-tight">
            Sort Sheets by Tab Name
          </h1>

          {/* Author and Actions Section */}
          <div className="mb-4">
            {/* Desktop: Full profile info on left, buttons on right */}
            <div className="hidden md:flex items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                <img src={macroVaultLogo} alt="MacroVault" className="w-10 h-10 rounded-full object-cover" loading="lazy" />
                <div>
                  <div className="flex items-center gap-1.5 font-medium text-foreground">
                    MacroVault
                    <img src={verifiedBadge} alt="Verified" className="w-5 h-5" loading="lazy" />
                  </div>
                  <div className="text-sm text-muted-foreground">12.3k followers</div>
                </div>
              </div>
              
              <div className="flex items-center gap-2">
                {/* Like/Dislike Combined Pill */}
                <div className="flex items-center rounded-full bg-muted overflow-hidden border border-border/30">
                  <button className="flex items-center gap-1.5 px-4 py-2 hover:bg-background/50 transition-all duration-200 border-r border-border/30">
                    <ThumbsUp className="h-4 w-4" />
                    <span className="text-sm">Like</span>
                  </button>
                  <button className="flex items-center gap-1.5 px-4 py-2 hover:bg-background/50 transition-all duration-200" aria-label="Dislike">
                    <ThumbsDown className="h-4 w-4" />
                  </button>
                </div>
                
                {/* Add to Excel Button */}
                <button className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-muted text-foreground border border-border/30 hover:bg-background/50 transition-colors text-sm font-medium">
                  <ExternalLink className="h-4 w-4" />
                  Add to Excel
                </button>
                
                {/* Save Button */}
                <button className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-muted text-foreground border border-border/30 hover:bg-background/50 transition-colors text-sm font-medium">
                  <Bookmark className="h-4 w-4" />
                  Save
                </button>
                
                {/* More Options Button */}
                <button className="flex items-center justify-center w-10 h-10 rounded-full bg-muted text-foreground border border-border/30 hover:bg-background/50 transition-colors" aria-label="More options">
                  <MoreHorizontal className="h-4 w-4" />
                </button>
              </div>
            </div>

            {/* Mobile: Horizontal scrollable with avatar + buttons */}
            <div className="md:hidden overflow-x-auto scrollbar-hide">
              <div className="flex items-center gap-2 min-w-max">
                {/* Avatar */}
                <img src={macroVaultLogo} alt="MacroVault" className="w-10 h-10 rounded-full object-cover flex-shrink-0" loading="lazy" />

                {/* Like/Dislike buttons */}
                <div className="flex items-center rounded-full bg-muted overflow-hidden border border-border/30">
                  <button className="flex items-center gap-1.5 px-4 py-2 hover:bg-background/50 transition-all duration-200 border-r border-border/30">
                    <ThumbsUp className="h-4 w-4" />
                    <span className="text-sm">Like</span>
                  </button>
                  <button className="flex items-center gap-1.5 px-4 py-2 hover:bg-background/50 transition-all duration-200" aria-label="Dislike">
                    <ThumbsDown className="h-4 w-4" />
                  </button>
                </div>

                {/* Add to Excel button */}
                <button className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-muted text-foreground border border-border/30 hover:bg-background/50 hover:text-foreground transition-colors text-sm font-medium whitespace-nowrap">
                  <ExternalLink className="h-4 w-4" />
                  Add to Excel
                </button>

                {/* Save button */}
                <button className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-muted border border-border/30 hover:bg-background/50 transition-colors text-sm font-medium">
                  <Bookmark className="h-4 w-4" />
                  Save
                </button>

                {/* More options button */}
                <button className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-muted border border-border/30 hover:bg-background/50 transition-colors text-sm font-medium" aria-label="More options">
                  <MoreHorizontal className="h-4 w-4" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};